import * as React from "react";
import type { SVGProps } from "react";
const SvgHighSpeedInternetIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14 3.92C8.741 3.92 3.96 6.009.438 9.39l-.405.39 3.1 3.231.406-.39A15.05 15.05 0 0 1 14 8.4c4.06 0 7.742 1.61 10.463 4.222l.404.39 3.1-3.232-.404-.39C24.04 6.01 19.258 3.92 14 3.92m0 1.12c4.76 0 9.067 1.844 12.346 4.81l-1.549 1.612C21.924 8.886 18.155 7.28 14 7.28S6.077 8.886 3.203 11.462L1.653 9.85C4.934 6.884 9.24 5.04 14 5.04m0 5.6c-3.454 0-6.6 1.374-8.912 3.596l-.405.387 3.113 3.244.403-.389C9.713 16.023 11.745 15.12 14 15.12s4.288.903 5.801 2.358l.403.39 3.113-3.245-.403-.387A12.84 12.84 0 0 0 14 10.64m0 1.12c2.957 0 5.63 1.127 7.698 2.933l-1.562 1.626c-1.658-1.42-3.784-2.32-6.136-2.32-2.351 0-4.478.9-6.136 2.32l-1.562-1.626C8.37 12.887 11.042 11.76 14 11.76m0 5.6a6.14 6.14 0 0 0-4.261 1.721l-.403.388L14 24.327l.402-.42 4.262-4.438-.403-.388A6.14 6.14 0 0 0 14 17.36m0 1.12c1.15 0 2.161.446 3.01 1.096L14 22.713l-3.01-3.137c.849-.65 1.86-1.096 3.01-1.096"
    />
  </svg>
);
export default SvgHighSpeedInternetIcon;
